import { currentLotterySeason } from '@/common/config/onboarding-config';

// Мови, для яких намальована локалізована картинка сезону
const imageLanguages = ['en', 'ru'] as const;

type ImageLanguage = (typeof imageLanguages)[number];

const isImageLanguage = (language: string): language is ImageLanguage =>
  imageLanguages.includes(language as ImageLanguage);

// /img/lottery/welcome-lottery-{season}-{lang}.png
const getWelcomeLotteryImage = (language: string): string => {
  const shortLanguage = language.split('-')[0];
  const suffix = isImageLanguage(shortLanguage) ? shortLanguage : 'en';

  return `/img/lottery/welcome-lottery-${currentLotterySeason}-${suffix}.png`;
};

export { getWelcomeLotteryImage };
